import type { AxiosRequestConfig, AxiosResponse } from 'axios';
import type { Action } from 'redux';

export interface LegacyAction extends Action<string> {
  [key: string]: unknown;
  meta?: unknown;
}

export interface LegacyApiMeta {
  type: 'api';
  url: string;
  method: NonNullable<AxiosRequestConfig['method']>;
  params?: unknown;
  data?: unknown;
  onSuccess?: () => void;
  onSettled?: () => void;
  error?: Partial<Record<string, string>>;
}

export interface LegacyApiAction extends LegacyAction {
  meta: LegacyApiMeta;
}

export const isLegacyApiAction = (
  action: LegacyAction,
): action is LegacyApiAction => {
  const { meta } = action;

  return (
    typeof meta === 'object' &&
    meta !== null &&
    'type' in meta &&
    meta.type === 'api'
  );
};

export interface ApiErrorMetadata {
  status: string;
  msg: string;
  details?: unknown;
}

export interface LegacyMiddlewareStore {
  dispatch: (action: LegacyAction) => unknown;
}

export type LegacyDispatch = (action: LegacyAction) => unknown;

export type LegacyApiResponse = Pick<AxiosResponse<unknown>, 'data' | 'status'>;
